import Lightbox from 'bs5-lightbox'

const LightboxConfig = () => {
    var returnObj = {};
    /**
     * BS5 Lightbox
     *
     * activate and configuration the plugin
     * adding that can used lazysizes
     * and adding a Zoom-Icon-Button, Video-Icon-Button
     */

    // delegate calls to data-bs-toggle="lightbox"
    returnObj.lightboxMaskBtnPos = function (e, type) {
        jQuery(e).next().removeAttr('style');

        if (type === 'video') {
            var imgWidth = jQuery(e).children().outerWidth() + parseFloat(jQuery(e).children().css('margin-left')) + parseFloat(jQuery(e).children().css('margin-right'));
            var imgHeight = jQuery(e).children().outerHeight() + parseFloat(jQuery(e).children().css('margin-top')) + parseFloat(jQuery(e).children().css('margin-bottom'));
            var fontSize = parseFloat(jQuery(e).next().css('font-size'));
            var divider = 1;

            if (imgHeight >= 300 || imgWidth >= 300) {
                divider = 2;
            }
            if (imgHeight >= 500 || imgWidth >= 500) {
                divider = 3;
            }
            fontSize *= divider;
            jQuery(e).next().css({
                'font-size': fontSize + 'px',
            });


            imgWidth = jQuery(e).children().outerWidth() + parseFloat(jQuery(e).children().css('margin-left')) + parseFloat(jQuery(e).children().css('margin-right'));
            imgHeight = jQuery(e).children().outerHeight() + parseFloat(jQuery(e).children().css('margin-top')) + parseFloat(jQuery(e).children().css('margin-bottom'));
            var iconWidth = jQuery(e).next().outerWidth();
            var iconHeight = jQuery(e).next().outerHeight();

            jQuery(e).next().css({
                'left': ((imgWidth / 2) - (iconWidth / 2)),
                'top': ((imgHeight / 2) - (iconHeight / 2))
            })
        } else if (type === 'lightbox') {
            const parent = jQuery(e.parentElement);
            parent.find('.lightbox-mask').css('bottom', parseFloat(parent.find('span.lightbox-mask + p').outerHeight()));
        }
    };

    /**
     * initial rendering the special button on image
     *
     * @param type
     */
    returnObj.initMask = function (type, $selector) {
        if (!$selector) {
            $selector = jQuery(document);
        } else if (!($selector instanceof $)) {
            $selector = jQuery($selector);
        }
        var iconClass = 'search';
        if (type == "video") {
            iconClass = "play";
        }
        $selector.find('*[data-mask="' + type + '"]').each(function (i, e) {
            if (jQuery(e).next('.' + type + '-mask').length == 0) {
                jQuery(e).after('<span class="' + type + '-mask glyphicons glyphicons-' + iconClass + '"></span>');
            }
            returnObj.lightboxMaskBtnPos(e, type);
        });
        $selector.find('[data-mask="' + type + '"] img').on('load', function () {
            if (jQuery(this).hasClass('lazyloaded')) {
                returnObj.lightboxMaskBtnPos(jQuery(this).parent(), type);
            }
        });
    }

    /**
     * initial lightbox event on the new image-button (maske)
     */
    returnObj.initLightbox = function () {
        /** fixing the click event - the mask is over the lightbox image (click event) */
        jQuery('.lightbox-mask').on('click', function (e) {
            jQuery(e.currentTarget).parent().find('*[data-setu-toggle="lightbox"]').click();
            return false;
        });

        jQuery(document).on('click', '*[data-setu-toggle="lightbox"]', function (event) {
            event.preventDefault();
            // fixing for automatic title and caption filling // @TODO is his needed?
            jQuery(event.currentTarget).attr({
                'data-title': jQuery(event.currentTarget).children().attr('alt') || '',
                'data-footer': jQuery(event.currentTarget).parent().find('p').html() || '',
            });

            const lightBox = new Lightbox(event.currentTarget, {});
            const showEventHandler = showEvent => {
                let lazyData = jQuery(event.currentTarget).find('[data-srcset]').attr('data-srcset');
                $(showEvent.currentTarget).find('.carousel-item .ratio.ratio-16x9').each((index, item) => {
                    item.style.backgroundColor = '#fff';
                    if (!!lazyData) {
                        item.classList.add('intrinsic')
                    }
                });

                if (!!jQuery(event.currentTarget).attr('data-gallery')) {
                    $(showEvent.currentTarget).find('.carousel-control.carousel-control-next').html('<span class="glyphicons glyphicons-chevron-right"></span><span class="visually-hidden">Next</span>')
                    $(showEvent.currentTarget).find('.carousel-control.carousel-control-prev').html('<span class="glyphicons glyphicons-chevron-left"></span><span class="visually-hidden">Previous</span>')
                }

                if (!!lazyData) {
                    jQuery(showEvent.currentTarget).find('img').attr({
                        'data-srcset': lazyData,
                        'data-sizes': 'auto'
                    }).addClass('lazyload');
                }
                const caption = showEvent.currentTarget.querySelector('.lightbox-caption');
                if (caption instanceof Element) {
                    caption.classList.replace('text-white', 'bg-white')
                }
            };
            const slideEventHandler = slideEvent => {
                // fixing for automatic title and caption filling // @TODO is his needed?
                jQuery(event.currentTarget).attr({
                    'data-title': jQuery(event.currentTarget).children().attr('alt') || '',
                    'data-footer': jQuery(event.currentTarget).parent().find('p').html() || '',
                });
            };

            lightBox.modalElement.addEventListener('show.bs.modal', showEventHandler, {passive: true});
            lightBox.modalElement.addEventListener('slide.bs.carousel', slideEventHandler, {passive: true});
            lightBox.modalElement.addEventListener('hide.bs.modal', () => {
                lightBox.modalElement.removeEventListener('show.bs.modal', showEventHandler);
                lightBox.modalElement.removeEventListener('slide.bs.carousel', showEventHandler);
            }, {once: true, passive: true});

            lightBox.show();
        });
    }

    /**
     * initial all needed for first load
     */
    returnObj.init = function () {
        returnObj.initMask('lightbox');
        returnObj.initMask('video');
        returnObj.initLightbox();
    }

    /**
     * initial action
     */
    returnObj.init();

    return returnObj;
}
export const lightboxConfig = LightboxConfig();
